module.exports = __webpack_public_path__ + "static/media/loginImg.e991e8c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loginImg.png
// module id = 1088
// module chunks = 1